import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9aeec3ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard ff-bottom-fixed-cta" }
const _hoisted_2 = { class: "profile-creation-wizard__container" }
const _hoisted_3 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_4 = { class: "profile-creation-wizard__content" }
const _hoisted_5 = { class: "profile-creation-wizard__content-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!
  const _component_step_mobile_header = _resolveComponent("step-mobile-header")!
  const _component_ask_for_recommendation = _resolveComponent("ask-for-recommendation")!
  const _component_step_actions = _resolveComponent("step-actions")!
  const _component_recommandation_side = _resolveComponent("recommandation-side")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_joy_progress_bar, { percentage: _ctx.progressPercentage }, null, 8, ["percentage"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_step_mobile_header, {
            "step-name": _ctx.stepName,
            "onClick:previous": _ctx.goToPrevious
          }, null, 8, ["step-name", "onClick:previous"]),
          _createVNode(_component_ask_for_recommendation, {
            onEmailsChanged: _ctx.changeRecoEmails,
            onTextChanged: _ctx.changeRecoText
          }, null, 8, ["onEmailsChanged", "onTextChanged"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_joy_progress_bar, {
            percentage: _ctx.progressPercentage,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(_component_step_actions, {
            "step-name": _ctx.stepName,
            "show-button-skip": true,
            "is-disabled-button-next": !_ctx.hasValidFieldPart,
            "is-hidden-button-skip": _ctx.hasValidFieldPart,
            "is-loading-button-next": _ctx.isLoadingButtonNext,
            "onClick:next": _ctx.goNext,
            "onClick:skip": _ctx.goNext,
            "onClick:previous": _ctx.goToPrevious
          }, null, 8, ["step-name", "is-disabled-button-next", "is-hidden-button-skip", "is-loading-button-next", "onClick:next", "onClick:skip", "onClick:previous"])
        ])
      ]),
      _createVNode(_component_recommandation_side)
    ])
  ]))
}